/**
 * Datas em formato humano (pt-BR). O backend fala ISO (`2026-07-16T09:35:00Z` ou
 * `2026-07-16`); a tela mostra `16/07/2026 09:35` ou `16/07/2026`. Diferente das
 * máscaras de documento, aqui não há valor de volta para o banco — é só exibição.
 */

const ISO_DATA = /^\d{4}-\d{2}-\d{2}$/;
const ISO_DATA_HORA = /^\d{4}-\d{2}-\d{2}T/;

export function formatarDataHora(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatarData(iso: string | null | undefined): string {
  if (!iso) return '';
  // Data pura não tem fuso: parsear como UTC evita "voltar um dia" em fusos negativos.
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('pt-BR');
}

/** Idade em anos a partir de uma data de nascimento ISO ('YYYY-MM-DD'). `null` se a data é inválida
 * ou futura. Calcula na tela (o mesmo valor que o trigger do banco deriva). */
export function idadeDeData(iso: string | null | undefined): number | null {
  if (!iso || !ISO_DATA.test(iso)) return null;
  const nasc = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(nasc.getTime())) return null;
  const hoje = new Date();
  let anos = hoje.getFullYear() - nasc.getFullYear();
  const m = hoje.getMonth() - nasc.getMonth();
  if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) anos -= 1;
  return anos < 0 || anos > 150 ? null : anos;
}

/** Humaniza se o valor for uma data/datahora ISO; senão devolve como está. */
export function humanizarSeData(valor: string): string {
  if (ISO_DATA_HORA.test(valor)) return formatarDataHora(valor);
  if (ISO_DATA.test(valor)) return formatarData(valor);
  return valor;
}
